<template>
  <div class="home">
    <van-nav-bar
      :title="$t('NewShop.title')"
      left-arrow
      fixed
      @click-left="$router.push('/ShopList')"
    >
      <van-icon
        name="./static/img/ok.png"
        slot="right"
        @click="createShop()"
        style="font-size: 24px;"
      />
    </van-nav-bar>
    <van-cell-group>
      <!-- 店铺类型 -->
      <van-field
        v-model="cateShop"
        left-icon="static/img/shopleixing.png"
        :label="$t('NewShop.shopType')"
        :placeholder="$t('NewShop.chooseShopType')"
        readonly
        right-icon="arrow"
        @click="showCategory = true"
      />
      <van-popup v-model="showCategory" position="bottom">
        <van-picker
          show-toolbar
          :columns="shopCategory"
          @cancel="showCategory = false"
          @confirm="omConfirmCategory"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
        />
      </van-popup>

      <van-field
        v-model="shop.name"
        left-icon="static/img/shopname.png"
        :label="$t('NewShop.name')"
        clearable
        :placeholder="$t('EditShop.inputName')"
      />
      <van-field
        type="textarea"
        v-model="shop.address"
        left-icon="./static/img/local.png"
        :label="$t('NewShop.address')"
        clearable
        :placeholder="$t('EditShop.inputAddress')"
      />
      <van-cell
        :title="$t('NewShop.pic')"
        icon="./static/img/image.png"
        title-style="width: 125px;flex:none;"
      >
        <van-uploader :after-read="afterRead">
          <van-image v-if="shop.img" width="55" height="55" :src="shop.img" />
          <van-image
            v-else
            width="55"
            height="55"
            fit="contain"
            src="./static/img/add_img.png"
          />
        </van-uploader>
      </van-cell>

      <van-field
        v-model="shop.phone"
        left-icon="./static/img/tele.png"
        :label="$t('NewShop.phone')"
        clearable
        :placeholder="$t('EditShop.inputPhone')"
      />
      <!-- 开店时间 -->
      <van-field
        readonly
        v-model="shop.start_time"
        right-icon="arrow"
        :label="$t('NewShop.startTime')"
        :placeholder="$t('NewShop.chooseStartTime')"
        left-icon="./static/img/Business_time.png"
        @click="startTimePicker = true"
      />
      <van-popup v-model="startTimePicker" position="bottom">
        <van-datetime-picker
          v-model="shop.start_time"
          type="time"
          :min-hour="0"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
          @cancel="startTimePicker = false"
          @confirm="onConfirmStartTime"
        />
      </van-popup>

      <van-field
        readonly
        v-model="shop.after_start"
        :label="$t('EditShop.startAfterTime')"
        :placeholder="$t('EditShop.chooseStartAfterTime')"
        left-icon="./static/img/Business_time.png"
        @click.stop="afterStartPicker = true"
      >
        <template slot="button">
          <van-icon
            v-if="shop.after_start"
            name="clear"
            @click.stop="handleClearStartTime"
          />
          <van-icon name="arrow" @click.stop="afterStartPicker = true" />
        </template>
      </van-field>
      <van-popup v-model="afterStartPicker" position="bottom">
        <van-datetime-picker
          v-model="shop.after_start"
          type="time"
          :min-hour="0"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
          @cancel="afterStartPicker = false"
          @confirm="onConfirmAfterStart"
        />
      </van-popup>
      <van-field
        readonly
        v-model="shop.after_end"
        :label="$t('EditShop.endAfterTime')"
        :placeholder="$t('EditShop.chooseEndAfterTime')"
        left-icon="./static/img/Business_time.png"
        @click.stop="afterEndPicker = true"
      >
        <template slot="button">
          <van-icon
            v-if="shop.after_end"
            name="clear"
            @click.stop="handleClearEndTime"
          />
          <van-icon name="arrow" @click.stop="afterEndPicker = true" />
        </template>
      </van-field>
      <van-popup v-model="afterEndPicker" position="bottom">
        <van-datetime-picker
          v-model="shop.after_end"
          type="time"
          :min-hour="0"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
          @cancel="afterEndPicker = false"
          @confirm="onConfirmAfterEnd"
        />
      </van-popup>

      <van-field
        readonly
        v-model="shop.end_time"
        right-icon="arrow"
        :label="$t('NewShop.endTime')"
        :placeholder="$t('NewShop.chooseEndTime')"
        left-icon="./static/img/Business_time.png"
        @click="endTimePicker = true"
      />
      <van-popup v-model="endTimePicker" position="bottom">
        <van-datetime-picker
          v-model="shop.end_time"
          type="time"
          :min-hour="0"
          @cancel="endTimePicker = false"
          @confirm="onConfirmEndTime"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
        />
      </van-popup>

      <!-- </van-panel> -->
      <van-field
        readonly
        clickable
        left-icon="./static/img/cook_speed.png"
        right-icon="arrow"
        :label="$t('NewShop.timeLimit')"
        :value="shop.set_time + $t('NewShop.minute')"
        :placeholder="$t('NewShop.cookTime')"
        @click="showSetTimePicker = true"
      />
      <van-field
        v-model="shop.intro"
        type="textarea"
        autosize
        clickable
        left-icon="./static/img/introduction.png"
        :label="$t('NewShop.intro')"
        :placeholder="$t('NewShop.inputIntro')"
      />
    </van-cell-group>
    <van-popup v-model="showSetTimePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="cookTimes"
        @cancel="showSetTimePicker = false"
        @confirm="onConfirm"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
      />
    </van-popup>
    <!-- 语言选择 -->
    <van-field
      :label="$t('NewShop.chooseL')"
      @click="showLanguage = true"
      :placeholder="$t('center.chooseLang')"
      v-model="lang"
      left-icon="./static/img/yuyan.png"
      is-link
    ></van-field>
    <van-popup v-model="showLanguage" position="bottom">
      <van-picker
        show-toolbar
        :columns="language"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
        @cancel="showLanguage = false"
        @confirm="getLang"
      />
    </van-popup>

    <!-- 货币选择 -->
    <van-field
      :label="$t('EditShop.currency')"
      @click="showcurrency = true"
      :placeholder="$t('EditShop.chooseCurrency')"
      v-model="currencyVal"
      left-icon="./static/img/yuyan.png"
      is-link
    ></van-field>
    <van-popup v-model="showcurrency" position="bottom">
      <van-picker
        show-toolbar
        :columns="currency"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
        @cancel="showcurrency = false"
        @confirm="onConfirmCurrency"
      />
    </van-popup>

    <!-- 颜色选择 -->
    <van-field
      :label="$t('EditShop.color')"
      class="colorSelect"
      @click="showcolor = true"
      :placeholder="$t('EditShop.inputColor')"
      v-model="colorVal"
      left-icon="./static/img/yuyan.png"
      is-link
    ></van-field>
    <van-popup v-model="showcolor" position="bottom">
      <van-picker
        show-toolbar
        :columns="colorData"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
        @cancel="showcolor = false"
        @confirm="onConfirmColor"
      />
    </van-popup>

    <!-- 外卖时限 -->
    <van-field
      readonly
      clickable
      left-icon="./static/img/Business_time.png"
      right-icon="arrow"
      :label="$t('EditShop.fail_time')"
      :value="shop.fail_time + $t('NewShop.hour')"
      :placeholder="$t('EditShop.inputFail_time')"
      @click="showFailTimePicker = true"
    />
    <van-popup v-model="showFailTimePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="failTimes"
        @cancel="showFailTimePicker = false"
        @confirm="onConfirmFailTime"
        :confirm-button-text="$t('vantText.confirm')"
        :cancel-button-text="$t('vantText.cancel')"
      />
    </van-popup>
    <!-- <div>
      <!== 快捷点菜开关 ==>
      <van-cell :title="$t('EditShop.isQuick')">
        <van-switch
          v-model="is_quick"
          @input="changeQuickSet"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>

      <!== 服务费开关 ==>
      <van-cell :title="$t('EditShop.isServiceCharge')">
        <van-switch
          v-model="service"
          @input="changeServiceSet"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>

      <!== 服务费百分比 ==>
      <van-field
        v-if="service"
        v-model="shop.service_charge"
        :label="$t('EditShop.serviceCharge') + '(%)'"
        type="digit"
        clearable
        :placeholder="$t('EditShop.serviceCharge')"
      />

      <!== 折扣费开关 ==>
      <van-cell :title="$t('EditShop.isDiscountFee')">
        <van-switch
          v-model="discount"
          @input="changeDiscountSet"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>

      <!== 设置金额精度 ==>
      <van-cell :title="$t('EditShop.isFloat')">
        <van-switch
          v-model="isFloat"
          @input="changeFloatSet"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>
      <!== 设置地区运费 ==>
      <van-cell :title="$t('EditShop.isAdditional')">
        <van-switch
          v-model="isAdditional"
          @input="changeAddSet"
          active-color="#2f75f7"
          inactive-color="#ee0a24"
        />
      </van-cell>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      shop: {
        name: "",
        address: "",
        img: "",
        image_id: "",
        phone: "",
        start_time: "09:00", // 开店时间
        after_start: "14:00", // 开始午休
        after_end: "16:00", // 结束午休
        end_time: "22:00", // 关店时间
        set_time: "30", // 服务时间
        intro: "店铺介绍", // 店铺介绍
        language_id: "2",
        color_id: "1",
        type_id: "",
        currency_id: "",
        is_quick: "0",
        service: "0",
        service_charge: "0",
        discount: "0",
        is_accuracy: "0",
        is_additional: "0",
        fail_time: "0"
      },
      is_quick: false,
      service: false,
      discount: false,
      isFloat: false,
      isAdditional: false,

      shopCategory: [],
      showCategory: false,
      cookTimes: [
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "45",
        "50",
        "55",
        "60"
      ],
      showSetTimePicker: false,

      failTimes: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24"
      ],
      showFailTimePicker: false,

      showStartTimePicker: false,
      startTimePicker: false,
      afterStartPicker: false,
      afterEndPicker: false,
      endTimePicker: false,
      langList: [],
      showLanguage: false,
      language: [],
      lang: "",
      cateShop: "",
      categoryList: [],
      getLangs: "",
      showcurrency: false,
      currencyList: [],
      currency: [],
      currencyVal: "美元 $",

      showcolor: false,
      colorData: [],
      colorList: [],
      colorVal: ""
    };
  },
  mounted: function() {
    this.getLangList(), this.getCategoryList();
    this.getLangs = this.$i18n.locale;
    this.getCurrencyList();
    this.getColorList();
  },
  methods: {
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append("type", "shop");
      formData.append("file", file.file);
      this.$axios({
        method: "post",
        url: this.$build + "/api/image",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + sessionStorage.token
        },
        data: formData
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shop.image_id = res.data.success.image_id;
            this.shop.img = res.data.success.url;
            // this.$toast({
            // 	type:'success',
            // 	message:res.data.message,
            // });
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message")
          });
        });
    },
    // 清除时间
    handleClearStartTime() {
      this.shop.after_start = "";
    },
    handleClearEndTime(e) {
      this.shop.after_end = "";
    },
    onConfirm(value, index) {
      this.shop.set_time = value;
      this.showSetTimePicker = false;
    },
    onConfirmFailTime(value, index) {
      this.shop.fail_time = value;
      this.showFailTimePicker = false;
    },
    onConfirmStartTime(value, index) {
      this.shop.start_time = value;
      this.startTimePicker = false;
    },
    onConfirmAfterStart(value, index) {
      this.shop.after_start = value;
      this.afterStartPicker = false;
    },
    onConfirmAfterEnd(value, index) {
      this.shop.after_end = value;
      this.afterEndPicker = false;
    },
    onConfirmEndTime(value, index) {
      this.shop.End_time = value;
      this.endTimePicker = false;
    },
    createShop() {
      if (
        this.shop.name &&
        this.shop.address &&
        this.shop.phone &&
        this.shop.set_time &&
        this.shop.language_id &&
        this.shop.currency_id
      ) {
        this.$axios({
          method: "post",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/store/store",
          data: this.shop
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              const vm = this;
              setTimeout(function() {
                vm.$router.push("/ShopList");
              }, 1500);
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("NewShop.message")
            });
          });
      } else {
        this.$toast(this.$t("NewShop.toast"));
      }
    },
    getLangList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/language/index"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.langList = res.data.data;
            for (var i = 0; i < this.langList.length; i++) {
              this.language.push(this.langList[i].name_cn);
            }
            this.getLang("", 2);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message")
          });
        });
    },
    getLang(value, index) {
      this.showLanguage = false;
      console.log(this.langList);
      this.shop.language_id = this.langList[index].id;
      console.log(this.shop.language_id);
      if (this.shop.language_id == 1) {
        this.lang = "English";
      } else if (this.shop.language_id == 2) {
        this.lang = "繁體中文";
      } else if (this.shop.language_id == 3) {
        this.lang = "简体中文";
      }
    },
    omConfirmCategory(value, index) {
      this.showCategory = false;
      this.shop.type_id = this.categoryList[index].id;
      this.cateShop = value;
      sessionStorage.setItem("categoryValue", value);
    },

    // 获取店铺类型列表
    getCategoryList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/type/index"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            console.log(res);
            this.categoryList = res.data.data;
            for (var i = 0; i < this.categoryList.length; i++) {
              if (this.getLangs == "zh") {
                this.shopCategory.push(this.categoryList[i].name_cn);
              } else if (this.getLangs == "hk") {
                this.shopCategory.push(this.categoryList[i].name_hk);
              } else if (this.getLangs == "en") {
                this.shopCategory.push(this.categoryList[i].name_en);
              } else {
                this.shopCategory.push(this.categoryList[i].name_en);
              }
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message")
          });
        });
    },

    // 获取货币列表
    getCurrencyList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/currency/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.currencyList = res.data.data;
            console.log(res.data.data);
            for (var i = 0; i < this.currencyList.length; i++) {
              if (this.getLangs == "zh") {
                this.currency.push(
                  this.currencyList[i].name_cn + " " + this.currencyList[i].unit
                );
              } else if (this.getLangs == "hk") {
                this.currency.push(
                  this.currencyList[i].name_hk + " " + this.currencyList[i].unit
                );
              } else if (this.getLangs == "en") {
                this.currency.push(
                  this.currencyList[i].name_en + " " + this.currencyList[i].unit
                );
              } else {
                this.currency.push(
                  this.currencyList[i].name_en + " " + this.currencyList[i].unit
                );
              }
            }
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("NewShop.message")
          });
        });
    },

    changeQuickSet(is_quick) {
      this.is_quick = is_quick;
      this.shop.is_quick = is_quick ? "1" : "0";
    },
    changeServiceSet(service) {
      this.service = service;
      this.shop.service = service ? "1" : "0";
    },
    changeDiscountSet(discount) {
      this.discount = discount;
      this.shop.discount = discount ? "1" : "0";
    },
    changeFloatSet(isFloat) {
      this.isFloat = isFloat;
      this.shop.is_accuracy = isFloat ? "1" : "0";
    },
    changeAddSet(isAdditional) {
      this.isAdditional = isAdditional;
      this.shop.is_additional = isAdditional ? "1" : "0";
    },
    onConfirmCurrency(value, index) {
      this.showcurrency = false;
      console.log(value);
      this.currencyVal = value;
      this.shop.currency_id = this.currencyList[index].id;
    },

    getColorList() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/color/index"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.colorList = res.data.data;
            for (var i = 0; i < this.colorList.length; i++) {
              this.colorData.push(
                '<span style="width:20px;height:20px;float:left;margin-right:5px;background:' +
                  this.colorList[i].code +
                  '"></span> ' +
                  this.colorList[i].code
              );
            }
            this.onConfirmColor(this.colorData[1], 1);
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 确认按钮
    onConfirmColor(value, index) {
      console.log(value);
      this.showcolor = false;
      this.colorVal = value.substring(value.length - 7, value.length);
      console.log(this.colorVal);
      var seldiv = document.getElementsByClassName("colorSelect");
      var dom = seldiv[0].getElementsByClassName("van-cell__value");
      dom[0].style.background = this.colorVal;

      this.shop.color_id = this.colorList[index].id;
      sessionStorage.setItem("colorCode", this.colorVal);
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field__left-icon .van-icon {
  font-size: 20px;
}
/deep/ .van-cell .van-icon {
  font-size: 30px;
}
/deep/ .van-cell .van-icon-clear {
  font-size: 24px;
}
/deep/ .van-field__label {
  width: 125px;
}
/deep/ .van-image {
  font-size: 24px;
  vertical-align: top;
}
/deep/ .van-cell-group {
  margin-top: 46px;
}
.home {
  width: 100%;
  height: 100vh;
  background: #fff;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f7;
}
.van-cell-group {
  margin-top: 0;
}
.shopBottom {
  position: absolute;
  bottom: 0;
  height: 60px;
  background: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cancelBtn {
  width: 30%;
  top: 10%;
  left: 5%;
  background: #dfdede;
  font-weight: bold;
  font-size: 16px;
}
.certainBtn {
  width: 30%;
  top: 10%;
  right: 5%;
  background: linear-gradient(90deg, #ffc914, #ffb20d);
  font-weight: bold;
  font-size: 16px;
}
.van-cell__value {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/Shop/NewShop.vue